import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ShopInnerBanner from "./ShopInnerBanner";
import { UiBannerBottomBar } from "../../../../_uiComponents/common/UiBannerBottomBar";
import { UiContentWr } from "../../../../_uiComponents/common/UiPageElements";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../../_uiComponents/grid-container/GridContainer";
// import ProductContent from "./views/ProductContent";
// import TermsImg from "../../../styles/img/terms-img.jpg";
// import { WhatsIncluded } from "./views/WhatsIncluded";
// import { shopVoucherWalletRequest } from "../../../_redux/_actions";
// import OrderPointSection from "./views/OrderPointSection";
// import OrderContent from "./OrderContent";
import VoucherDetails from "./VoucherDetails";
import { UiBottomNavBar } from "../../../../_uiComponents/common/UiBottomNavBar";
// import { socket } from "../../../_helpers/support.services";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import TopHeader from "../../../../_uiComponents/common/custom/header/CustomTopHeader";
import Footer from "../../../../_uiComponents/common/custom/footer/CustomFooter";

export default function VoucherWallet() {  
    return (
        <>
         <div className='sb-renault-wr'>
            <UiMainWrapper>
                <TopHeader />
            <ShopInnerBanner
                title="Voucher Wallet"
                description="All your vouchers here"
            />
            <UiBannerBottomBar
                prevPage="Shop"
                prevPageLink="/app/shop/browse-products"
                currentPage="Voucher Wallet"
                currentPageLink="/app/shop/voucher-wallet"
            />
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12">
                        <VoucherDetails />
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
            <UiBottomNavBar />
            <Footer/>
            </UiMainWrapper>
            </div>
        </>
    );
}
